import { Navbar } from '../components/website/Navbar';
import DasboardImage from '../assets/website/dashboard.svg';
import Cards from '../components/website/Cards';
import Accordian from '../components/website/Accordian';
import Contact from '../components/website/Contact';
import Footer from '../components/website/Footer';
import './Website.css';
import JoinBeta from '../components/ui/JoinBeta';
import { useEffect } from 'react';
import { scroller } from 'react-scroll';

export function Website() {
  useEffect(() => {
    const scrollToSection = sessionStorage.getItem('scrollToSection');
    if (scrollToSection) {
      // Small delay to ensure the page has fully loaded
      setTimeout(() => {
        scroller.scrollTo(scrollToSection, {
          duration: 800,
          delay: 0,
          smooth: 'easeInOutQuart',
        });

        sessionStorage.removeItem('scrollToSection');
      }, 500);
    }
  }, []);

  return (
    <div className="Website">
      <Navbar />
      <section className="about">
        <div className="grid">
          <h1 className="header">
            Detect downtime <br /> before your customers do.
          </h1>
          <div>
            <p className="text">
              StatusTrust provides real-time monitoring, instant alerts, and customizable status pages that help you
              maintain service reliability and build customer trust through complete transparency.
            </p>
            <JoinBeta className={'website'} />

            {/* <Button onClick={() => window.open(getTargetUrl(), '_blank')} type="primary">
              <p>Get Started</p> <FaArrowRightLong className="website-btnicon" />
            </Button> */}
          </div>
        </div>
        <img src={DasboardImage} alt=" " className="dashboard-image" />
      </section>
      <section className="features">
        <Cards />
      </section>
      {/* <section className="testimonials">
        <Carousel />
      </section> */}
      <section className="faqs">
        <Accordian />
      </section>
      <section className="contact">
        <Contact />
      </section>
      <Footer />
    </div>
  );
}
